import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UploadFieldDesktop from '../atomicDesignDesktop/UploadFieldDesktop';
import useProSignupDocumentPanel from '../../../hooks/useProSignupDocumentPanel';
import JustificatifHelpDialog, { JustificatifType } from '../../pro/JustificatifHelpDialog';
import { getProDocumentUploadAccept } from '../../../utils/files/proDocumentUploadRules';

const SignUpPageDesktopProPanel3 = () => {
	const { t } = useTranslation();
	const [helpType, setHelpType] = useState<JustificatifType | null>(null);
	const {
		userInfo,
		isThirdPanelValidated,
		loadingSignup,
		shouldSkipDocumentUploadStep,
		openedPanel,
		setOpenedPanel,
		sectionTitle,
		sectionSubtitle,
		warningCompanyName,
		wrongFields,
		isMissingBackDialogOpen,
		handleFilesUpload,
		handleRemoveFile,
		handleValidate,
		handleMissingBackConfirm,
		handleMissingBackCancel,
	} = useProSignupDocumentPanel();
	const handleHelpFilesChange = (type: JustificatifType, files: FileList) => handleFilesUpload(type, files);

	return (
		<div
			style={{
				marginTop: 20,
				width: 1601,
				height: openedPanel === 'documents' ? (shouldSkipDocumentUploadStep ? 328 : 520) : 30,
				background: '#FFFFFF',
				borderRadius: 20,
				position: 'relative',
				padding: 24,
				boxShadow: '0px 1px 6px #00000029',
			}}
		>
			<div
				style={{
					fontSize: 25,
					fontWeight: 'bold',
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					cursor: 'pointer',
				}}
				onClick={() => setOpenedPanel(openedPanel === 'documents' ? '' : 'documents')}
			>
				<div
					style={{
						fontSize: 25,
						fontWeight: 'bold',
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						gap: 10,
					}}
				>
					{isThirdPanelValidated ? (
						<img
							src="/images/check-2.svg"
							alt="check"
							style={{
								width: 26,
								height: 26,
								marginBottom: -3,
								marginLeft: -8,
							}}
						/>
					) : (
						<div style={{ width: 18 }}/>
					)}
					{sectionTitle}
					{sectionSubtitle ? (
						<div
							style={{
								fontSize: 20,
								color: '#707070',
							}}
						>
							{sectionSubtitle}
						</div>
					) : null}
				</div>
				{openedPanel === 'documents' ? (
					<img
						src="/images/chevron-down.svg"
						alt="chevron-down"
						style={{ width: 20, height: 20 }}
					/>
				) : (
					<img
						src="/images/chevron-right.svg"
						alt="chevron-right"
						style={{ width: 24, height: 24 }}
					/>
				)}
			</div>
			{openedPanel === 'documents' && (
				<>
					{shouldSkipDocumentUploadStep ? (
						<div
							style={{
								margin: '22px 26px 0 26px',
								padding: '26px 32px',
								display: 'flex',
								flexDirection: 'column',
								gap: 14,
								borderRadius: 12,
								background: '#FFF4EC',
								borderLeft: '6px solid #FF4D00',
								color: '#323E48',
							}}
						>
							<div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
								<img src="/images/info.svg" alt="info" style={{ width: 30, height: 30 }} />
								<div style={{ fontSize: 24, fontWeight: 'bold' }}>
									{t('thirdPanel:dead_end_info_title', {
										companyName: warningCompanyName,
									})}
								</div>
							</div>
							<div style={{ fontSize: 20, lineHeight: 1.45, whiteSpace: 'pre-line' }}>
								{t('thirdPanel:dead_end_info_message')}
							</div>
						</div>
					) : (
						<div
							style={{
								margin: '6px 26px 0 26px',
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<UploadFieldDesktop
								label={t('thirdPanel:upload_company_registration')}
								helperText={t('thirdPanel:file_restrictions_company_registration')}
								accept={getProDocumentUploadAccept('companyRegistration')}
								onFilesChange={(files) => handleFilesUpload('companyRegistration', files)}
								uploadedFileNames={userInfo.documents?.companyRegistration?.map((file) => file.name)}
								onRemoveFile={(index) => handleRemoveFile('companyRegistration', index)}
								wrong={wrongFields.companyRegistration}
								wrongMessage={t('thirdPanel:wrong_company_registration')}
								onInfoLabel={t('thirdPanel:faq_companyRegistration_title')}
								emptyLabel={t('thirdPanel:upload_no_document')}
								dropPrefix={t('thirdPanel:upload_drop_prefix')}
								browseLabel={t('thirdPanel:upload_browse_action')}
								onInfoClick={() => setHelpType('companyRegistration')}
							/>
							<UploadFieldDesktop
								label={t('thirdPanel:upload_identity_card_front')}
								helperText={t('thirdPanel:file_restrictions_identity_card')}
								accept={getProDocumentUploadAccept('identityCard')}
								onFilesChange={(files) => handleFilesUpload('identityCard', files)}
								uploadedFileNames={userInfo.documents?.identityCard?.map((file) => file.name)}
								onRemoveFile={(index) => handleRemoveFile('identityCard', index)}
								wrong={wrongFields.identityCard}
								wrongMessage={t('thirdPanel:wrong_identity_card')}
								onInfoLabel={t('thirdPanel:faq_identityCard_title')}
								emptyLabel={t('thirdPanel:upload_no_document')}
								dropPrefix={t('thirdPanel:upload_drop_prefix')}
								browseLabel={t('thirdPanel:upload_browse_action')}
								onInfoClick={() => setHelpType('identityCard')}
							/>
							<UploadFieldDesktop
								label={t('thirdPanel:upload_identity_card_back')}
								helperText={t('thirdPanel:file_restrictions_identity_card')}
								accept={getProDocumentUploadAccept('identityCardBack')}
								onFilesChange={(files) => handleFilesUpload('identityCardBack', files)}
								uploadedFileNames={userInfo.documents?.identityCardBack?.map((file) => file.name)}
								onRemoveFile={(index) => handleRemoveFile('identityCardBack', index)}
								onInfoLabel={t('thirdPanel:faq_identityCardBack_title')}
								emptyLabel={t('thirdPanel:upload_no_document')}
								dropPrefix={t('thirdPanel:upload_drop_prefix')}
								browseLabel={t('thirdPanel:upload_browse_action')}
								onInfoClick={() => setHelpType('identityCardBack')}
							/>
							<div
								style={{
									marginTop: 18,
									padding: '14px 18px',
									display: 'flex',
									alignItems: 'center',
									gap: 16,
									borderRadius: 6,
									background: '#E8F5EA',
									borderLeft: '5px solid #2F6E3F',
									color: '#2F6E3F',
									fontSize: 18,
								}}
							>
								<img src="/images/info.svg" alt="info" style={{ width: 24, height: 24 }} />
								<div>{t('thirdPanel:identity_card_tip')}</div>
							</div>
						</div>
					)}
					<div
						style={{
							position: 'absolute',
							bottom: 24,
							right: 24,
							display: 'flex',
							flexDirection: 'column',
							gap: 5,
							justifyContent: 'end',
							alignItems: 'end',
						}}
					>
						<button
							disabled={loadingSignup}
							style={{
								padding: '0px 25px',
								height: 48,
								borderRadius: 10,
								backgroundColor: '#FF4D00',
								color: '#FFFFFF',
								border: 'none',
								fontSize: 19,
								fontWeight: 'bold',
								cursor: loadingSignup ? 'not-allowed' : 'pointer',
								opacity: loadingSignup ? 0.7 : 1,
								textTransform: 'uppercase',
							}}
							onClick={handleValidate}
						>
							{shouldSkipDocumentUploadStep
								? t('thirdPanel:dead_end_contact_cta')
								: t('thirdPanel:validate_button')}
						</button>
					</div>
					<Dialog
						open={isMissingBackDialogOpen}
						onClose={handleMissingBackCancel}
						PaperProps={{
							style: {
								width: 725,
								borderRadius: 18,
							},
						}}
					>
						<div
							style={{
								padding: '36px 34px',
								color: '#323E48',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								textAlign: 'center',
								gap: 18,
							}}
						>
							<div
								style={{
									width: 58,
									height: 58,
									borderRadius: '50%',
									background: '#FFF0E0',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<img src="/images/info.svg" alt="info" style={{ width: 26, height: 26 }} />
							</div>
							<div style={{ fontSize: 18, color: '#2F6E3F', background: '#E8F5EA', borderRadius: 999, padding: '4px 12px' }}>
								{t('thirdPanel:missing_identity_back_badge')}
							</div>
							<div style={{ fontSize: 26, fontWeight: 'bold' }}>
								{t('thirdPanel:missing_identity_back_title')}
							</div>
							<div style={{ fontSize: 18, lineHeight: 1.5, maxWidth: 560 }}>
								{t('thirdPanel:missing_identity_back_message')}
							</div>
							<div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
								<button
									style={{
										height: 54,
										padding: '0 26px',
										borderRadius: 10,
										background: '#FFFFFF',
										color: '#323E48',
										border: '1px solid #D9D9D9',
										fontSize: 17,
										fontWeight: 'bold',
										cursor: 'pointer',
										textTransform: 'uppercase',
									}}
									onClick={handleMissingBackConfirm}
								>
									{t('thirdPanel:missing_identity_back_confirm')}
								</button>
								<button
									style={{
										height: 54,
										padding: '0 26px',
										borderRadius: 10,
										background: '#FF4D00',
										color: '#FFFFFF',
										border: 'none',
										fontSize: 17,
										fontWeight: 'bold',
										cursor: 'pointer',
										textTransform: 'uppercase',
									}}
									onClick={handleMissingBackCancel}
								>
									{t('thirdPanel:missing_identity_back_cancel')}
								</button>
							</div>
						</div>
					</Dialog>
				</>
			)}
			<JustificatifHelpDialog
				open={helpType !== null}
				type={helpType}
				onClose={() => setHelpType(null)}
				onFilesChange={handleHelpFilesChange}			/>
		</div>
	);
};

export default SignUpPageDesktopProPanel3;
